import { render, staticRenderFns } from "./verivikasiPermohonanIzin.vue?vue&type=template&id=156aae7c&"
import script from "./verivikasiPermohonanIzin.vue?vue&type=script&lang=js&"
export * from "./verivikasiPermohonanIzin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QSeparator,QBtnGroup,QTooltip,QDialog,QImg,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QSeparator,QBtnGroup,QTooltip,QDialog,QImg})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
